import { Pipe, PipeTransform } from '@angular/core';
import {DefaultDataSchemaFriendlyNames} from '@app/views/admin/application-settings/models/data-schema-name.model';

@Pipe({
    name: 'schemaFriendlyName'
})
export class SchemaFriendlyNamePipe implements PipeTransform {

    transform(schema: string): any {
        return DefaultDataSchemaFriendlyNames[schema] || (schema || '').split('_').join(' ');
    }

}
